export const modifierNoFlip = {
  modifiers: {
    flip: {
      enabled: false
    }
  }
};
